<h2 mat-dialog-title>{{'Login' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <mat-form-field appearance="fill" style="min-width: 236px">
    <mat-label>{{'Enter your login' | translate}}</mat-label>
    <input matInput placeholder="Login" [(ngModel)]="login" [formControl]="loginFieldControl" (ngModelChange)="onInputChangeCheck()" required>
    <mat-error *ngIf="loginFieldControl.invalid">{{getErrorMessage(loginFieldControl) | translate}}</mat-error>
  </mat-form-field>
  <p>
    <mat-form-field appearance="fill">
      <mat-label>{{'Enter your password' | translate}}</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" [(ngModel)]="password" [formControl]="passwordFieldControl" (ngModelChange)="onInputChangeCheck()" required>
      <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <mat-error *ngIf="passwordFieldControl.invalid">{{getErrorMessage(passwordFieldControl) | translate}}</mat-error>
    </mat-form-field>
  </p>
  <p>
    <mat-checkbox [(ngModel)]="rememberMe">{{'Remember me' | translate}}</mat-checkbox>
  </p>
  <p>
    <button (click)="forgotPassword()" mat-button>{{'Forgot password' | translate}}</button>
  </p>
  <mat-error *ngIf="serverIsDown">{{'Server problem, contact an administrator' | translate}}</mat-error>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'Cancel' | translate}}</button>
  <button mat-button (click)="onLoginUser()" [disabled]="allFieldsAreFilled()">{{'Login me' | translate}}</button>
</mat-dialog-actions>
